<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        {{ contenuAbonnement ? 'Modifier' : 'Ajouter' }} un contenu
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column ma-3 mt-10">
      <v-textarea
        v-model="contenuModifiable.sousTitre"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        class="mb-4"
        counter="70"
        label="Sous titre"
        maxlength="70"
        outlined
        required
        rows="1"
      />
      <v-textarea
        v-if="offre.isAbonnement"
        v-model="contenuModifiable.description"
        :disabled="loading"
        :rules="[rules.required]"
        auto-grow
        counter="150"
        label="Description"
        maxlength="150"
        outlined
        required
        rows="1"
      />
    </div>
    <div class="d-flex justify-space-around">
      <AgrButton
        :disabled="loading"
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="isBoutonValiderDisabled"
        class="pa-5"
        @click="enregistrerContenu()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex'
import {AgrButton} from '@agrial/ui'
import {clone} from '@/utils/clone'

export default {
  name: 'AjoutOffreAbonnementContenuModal',
  components: {AgrButton},
  props: {
    contenuAbonnement: {
      type: Object,
      default: null
    },
    offre: {
      type: Object,
      required: true
    },
  },

  data () {
    return {
      loading: false,
      erreur: false,
      contenuModifiable: {
        sousTitre: null,
        description: null,
      },
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
      }
    }
  },

  computed: {
      isBoutonValiderDisabled () {
        return this.loading || this.contenuModifiable.sousTitre === null || this.contenuModifiable.sousTitre === '' ||
          (this.offre.isAbonnement && (this.contenuModifiable.description === null || this.contenuModifiable.description === ''))
      }
  },

  created () {
    if (this.contenuAbonnement) {
      this.contenuModifiable = clone(this.contenuAbonnement)
    } else {
      this.contenuModifiable.ordre = this.offre.contenus.length
    }
  },

  methods: {
    ...mapActions({
      updateOffreAbonnementContenu: 'offreAbonnement/updateOffreAbonnementContenu'
    }),

    enregistrerContenu () {
      this.loading = true
      this.erreur = false

      const params = {
        offreID: this.offre.id,
        contenuAbonnement: this.contenuModifiable
      }
      this.updateOffreAbonnementContenu(params)
        .then(() => this.$emit('close'))
        .catch(() => this.erreur = true)
        .finally(() => this.loading = false)
    },

    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
